import type { Schemas } from '@shopware/api-client/api-types';
import { useRoute } from 'vue-router';

export function useNavigationPathHelper() {
    const { path: urlPath } = useRoute();

    const getCurrentSecondLevelNavigation = (elements: Schemas['NavigationRouteResponse']) => {
        if (!elements?.length) {
            return [];
        }
        const selectedFirstLevel = elements.find(element => isActive(element));

        if (!selectedFirstLevel?.children?.length) {
            return [];
        }

        return selectedFirstLevel.children;
    };

    const getPathForNavigationLevel = (level: number): string | undefined => {
        const currentPath = urlPath.toLowerCase();
        const allUrls = currentPath.split('/');
        const currentLevelPath = allUrls.slice(0, level).join('/');

        if (!currentLevelPath) {
            return;
        }

        return `${currentLevelPath}/`;
    };

    const getItemSeoUrl = (item: Schemas['Category']) => {
        const path = item.seoUrls?.[0]?.seoPathInfo.toLowerCase();

        return `/${path}`;
    };

    const isActive = (category: Schemas['Category'], isSelectedCategory: boolean = false) => {
        if (!category?.seoUrls) return false;

        const formattedPath = getItemSeoUrl(category);
        const currentPath = urlPath.toLowerCase();

        return isSelectedCategory ? formattedPath === currentPath : currentPath.includes(formattedPath);
    };

    return { isActive, getItemSeoUrl, getPathForNavigationLevel, getCurrentSecondLevelNavigation };
}
